import React, { useEffect, useState } from "react";
import "./media.css";
import playIcon from "assets/media/playIcon.png";
import videoIcon from "assets/media/videoIcon.png";
import imageZoomIcon from "assets/media/pic_zoom.png";
import Media_API from "../Media/API/MediaApi.json";
import Meta from "utils/meta";

const Media = () => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [mediaVideos, setMediaVideos] = useState([]);
  const [mediaImages, setMediaImages] = useState([]);
  const [imageUrl, setImageUrl] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [isVideoVisible, setIsVideoVisible] = useState(true);
  const [activeSection, setActiveSection] = useState("Videos");

  const fetchData = async () => {
    setMediaVideos(Media_API.media_videos);
  };

  useEffect(() => {
    fetchData();
  }, [mediaVideos]);

  const fetchImages = async () => {
    setMediaImages(Media_API.media_Images);
  };

  useEffect(() => {
    fetchImages();
  }, [mediaImages]);

  const handleThumbnailClick = (url) => {
    setVideoUrl(url);
    setIsPopupVisible(true);
  };

  const handleImagesClick = (imageUrl) => {
    setImageUrl(imageUrl);
    setIsPopupVisible(true);
  };
  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  const filteredVideos = mediaVideos.filter(
    (video) => selectedCategory === "All" || video.category === selectedCategory
  );

  const filteredImages = mediaImages.filter(
    (image) => selectedCategory === "All" || image.category === selectedCategory
  );

  const handleSectionMedia = (section) => {
    setActiveSection(section);
    setSelectedCategory("All");
    if (section === "Videos") {
      setIsVideoVisible(true);
    } else if (section === "Images") {
      setIsVideoVisible(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Meta title="Media | The Realtor Desk" description="" />
      <div className="media-container">
        <div className="row">
          <div className="col-12 filter-options">
            <div className="col-6 col-xs-4">
              <div className="sec-heading">
                <button
                  className={`sec-headline ${
                    activeSection === "Videos" ? "active" : ""
                  }`}
                  onClick={() => handleSectionMedia("Videos")}
                >
                  Videos
                </button>
                <button
                  className={`sec-headline ${
                    activeSection === "Images" ? "active" : ""
                  }`}
                  onClick={() => handleSectionMedia("Images")}
                >
                  Images
                </button>
              </div>
            </div>
            <div className="col-6 col-xs-8">
              <div className="pull-right">
                <button
                  onClick={() => handleCategoryClick("All")}
                  className={`all-stage ${
                    selectedCategory === "All" ? "active" : ""
                  }`}
                >
                  All
                </button>
                <button
                  onClick={() => handleCategoryClick("Sales")}
                  className={`sales-stage ${
                    selectedCategory === "Sales" ? "active" : ""
                  }`}
                >
                  Sales
                </button>
                <button
                  onClick={() => handleCategoryClick("Marketing")}
                  className={`marketing-stage ${
                    selectedCategory === "Marketing" ? "active" : ""
                  }`}
                >
                  Marketing
                </button>
              </div>
            </div>
          </div>
          {isVideoVisible && (
            <div className="col-12 video-container">
              {filteredVideos.map((video) => (
                <div
                  key={video.id}
                  className="col-4 col-sm-6 col-xs-12 vb-item"
                >
                  <a
                    href="#"
                    onClick={() => handleThumbnailClick(video.url)}
                    className="openVideo"
                  >
                    <div className="video-list">
                      <div className="video-section">
                        <img
                          alt={video.date}
                          className="img-full"
                          src={require("assets/media/" + `${video.thumbnail}`)}
                        />
                        <div className="play-icon-bg">
                          <div className="playIcon-wrapper">
                            <img
                              alt="Play Icon"
                              className="play-icon"
                              src={playIcon}
                            />
                          </div>
                        </div>
                        <img className="video-icon" src={videoIcon} alt="" />
                        <div className="video-category">{video.category}</div>
                      </div>
                      <div className="video-list-content">
                        <div className="date">
                          <p className="vp-date">{video.date}</p>
                        </div>
                        <h3 className="vp-description">{video.description}</h3>
                      </div>
                    </div>
                  </a>
                </div>
              ))}
              {isPopupVisible && (
                <div className="overlay">
                  <div className="video-popup">
                    <button
                      onClick={() => setIsPopupVisible(false)}
                      className="close-icon"
                    >
                      &times;
                    </button>
                    <div className="popup-content">
                      <iframe
                        href="#"
                        className="popup-video"
                        width="640"
                        height="390"
                        src={videoUrl}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          {!isVideoVisible && (
            <div className="col-12 images-container">
              {filteredImages.map((image) => (
                <div
                  key={image.id}
                  className="col-4 col-sm-6 col-xs-12 images-item"
                >
                  <a
                    href="#"
                    onClick={() =>
                      handleImagesClick(
                        require("assets/media/" + `${image.images}`)
                      )
                    }
                    className="openImages"
                  >
                    <div className="images-list">
                      <div className="images-section">
                        <img
                          alt={image.date}
                          className="images-full"
                          src={require("assets/media/" + `${image.images}`)}
                        />
                        <div className="image-zoom-icon">
                          <div className="image-zoom-wrapper">
                            <img
                              alt="Zoom Icon"
                              className="image-zoom"
                              src={imageZoomIcon}
                            />
                          </div>
                        </div>
                        <div className="images-category">{image.category}</div>
                      </div>
                    </div>
                  </a>
                </div>
              ))}
              {isPopupVisible && (
                <div className="overlay">
                  <div className="images-popup">
                    <button
                      onClick={() => setIsPopupVisible(false)}
                      className="image-close-icon"
                    >
                      &times;
                    </button>
                    <div className="images-popup-content">
                      <img
                        className="popup-image"
                        width="640"
                        height="500"
                        src={imageUrl}
                        alt="Selected"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Media;
